/* eslint-disable max-len */
import 'react';

const WarningSvg2 = (): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="prefix__c">
                <stop stopColor="#FF784F" offset="0%" />
                <stop stopColor="#FF4A4A" offset="100%" />
            </linearGradient>
            <linearGradient x1="47.918%" y1="-20.735%" x2="52.082%" y2="108.562%" id="prefix__d">
                <stop stopColor="#FFF" offset="0%" />
                <stop stopColor="#FFD7D8" offset="100%" />
            </linearGradient>
            <filter x="-31.2%" y="-25%" width="162.5%" height="162.5%" filterUnits="objectBoundingBox" id="prefix__a">
                <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur stdDeviation="1.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                <feColorMatrix
                    values="0 0 0 0 1 0 0 0 0 0.368627451 0 0 0 0 0.329411765 0 0 0 0.3 0"
                    in="shadowBlurOuter1"
                />
            </filter>
            <circle id="prefix__b" cx="8" cy="8" r="8" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <g opacity=".8" transform="translate(3 2)">
                <use fill="#000" filter="url(#prefix__a)" xlinkHref="#prefix__b" />
                <use fill="url(#prefix__c)" xlinkHref="#prefix__b" />
            </g>
            <path
                d="M1 8a1 1 0 110 2 1 1 0 010-2zM1 .2a.8.8 0 01.794.7L1.8 1v5a.8.8 0 01-1.594.1L.2 6V1A.8.8 0 011 .2z"
                transform="translate(10 5)"
                fill="url(#prefix__d)"
                fillRule="nonzero"
            />
        </g>
    </svg>
);
export default WarningSvg2;
